import { ShoppingBag, Truck, Warehouse, Factory } from "lucide-react";
import PageHeader from "../components/pageHeader";
import { useTranslation } from "../../../i18n/useTranslation";

const INDUSTRIES = [
  { Icon: ShoppingBag, title: "Retail", body: "Point-of-sale devices, handheld scanners, and inventory tools across store fleets." },
  { Icon: Truck, title: "Distribution", body: "Mobile computers and scanners keeping product moving accurately through distribution networks." },
  { Icon: Warehouse, title: "Warehousing", body: "Rugged devices built for high-volume, high-drop warehouse environments." },
  { Icon: Factory, title: "Manufacturing", body: "Floor-ready devices and lifecycle support for manufacturing operations." },
];

const Industries = () => {
  const { t } = useTranslation();
  const h = t("deviceworks.pageHeaders.industries");
  return (
    <div>
      <PageHeader eyebrow={h.eyebrow} title={h.title} />
      <div className="max-w-5xl mx-auto px-5 py-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        {INDUSTRIES.map(({ Icon, title, body }) => (
          <div key={title} className="dw-card">
            <Icon size={30} strokeWidth={1.5} style={{ color: "var(--dw-accent)" }} />
            <h3 className="pt-3">{title}</h3>
            <p className="dw-mini pt-1 text-sm">{body}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Industries;
